const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* Epix mobile custom builder checkout placement. This asset is loaded on every page. */
(function () {
  function placeEpixBuilderCheckout() {
    if (!window.matchMedia('(max-width: 768px)').matches) return;

    const deliveryContent = document.querySelector('.delivery-callout .delivery-content');
    const mobileButton = document.getElementById('submitOrderMobile');
    const mobileBar = mobileButton && mobileButton.closest('.mobile-cta-bar');
    const summaryToggle = document.getElementById('summaryToggle');
    const summaryContent = document.getElementById('summaryContent');
    const mobilePrice = mobileBar && mobileBar.querySelector('.price-value');

    if (!deliveryContent || !mobileButton || !mobileBar) return;

    if (!deliveryContent.contains(mobileBar)) {
      deliveryContent.appendChild(mobileBar);
    }

    mobileBar.classList.add('epix-builder-checkout-under-handcrafted');

    if (mobilePrice) {
      mobilePrice.style.display = 'none';
    }

    if (summaryToggle && !deliveryContent.contains(summaryToggle)) {
      deliveryContent.appendChild(summaryToggle);
    }

    if (summaryContent && !deliveryContent.contains(summaryContent)) {
      deliveryContent.appendChild(summaryContent);
    }

    if (!document.getElementById('epix-builder-mobile-checkout-style')) {
      const style = document.createElement('style');
      style.id = 'epix-builder-mobile-checkout-style';
      style.textContent = `
        @media screen and (max-width: 768px) {
          .delivery-content .epix-builder-checkout-under-handcrafted {
            display: flex !important;
            visibility: visible !important;
            opacity: 1 !important;
            width: 100% !important;
            margin: 18px 0 0 !important;
            padding: 14px !important;
            align-items: center !important;
            justify-content: center !important;
            gap: 12px !important;
            background: rgba(0, 0, 0, 0.45) !important;
            border: 1px solid rgba(87, 188, 214, 0.45) !important;
            border-radius: 12px !important;
            box-sizing: border-box !important;
          }

          .delivery-content .epix-builder-checkout-under-handcrafted .price-value {
            display: none !important;
          }

          .delivery-content .epix-builder-checkout-under-handcrafted #submitOrderMobile {
            display: flex !important;
            visibility: visible !important;
            min-height: 50px !important;
            width: 100% !important;
            flex: 1 1 100% !important;
            align-items: center !important;
            justify-content: center !important;
          }

          .delivery-content > #summaryToggle {
            display: block !important;
            visibility: visible !important;
            width: 100% !important;
            margin: 12px 0 0 !important;
            border-radius: 12px !important;
          }

          .delivery-content > #summaryContent {
            width: 100% !important;
            margin: 0 !important;
          }

          .delivery-content > #summaryContent.expanded {
            max-height: 50vh !important;
            opacity: 1 !important;
            overflow-y: auto !important;
          }
        }
      `;
      document.head.appendChild(style);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeEpixBuilderCheckout, { once: true });
  } else {
    placeEpixBuilderCheckout();
  }

  window.addEventListener('load', placeEpixBuilderCheckout, { once: true });
  setTimeout(placeEpixBuilderCheckout, 300);
  setTimeout(placeEpixBuilderCheckout, 1000);
})();

/* Raise custom builder configuration bar slightly on desktop only. */
(function () {
  function addDesktopSummaryOffset() {
    if (document.getElementById('epix-builder-desktop-summary-offset')) return;
    const style = document.createElement('style');
    style.id = 'epix-builder-desktop-summary-offset';
    style.textContent = `
      @media screen and (min-width: 769px) {
        .order-summary {
          bottom: 12px !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addDesktopSummaryOffset, { once: true });
  } else {
    addDesktopSummaryOffset();
  }
})();
